/*global ga*/

class Analytics {
  track() {
    ga('set', 'page', window.location.pathname);
    ga('send', 'pageview');
  }

  trackMailingListSubscribing(source = 'Unknown Source', eventValue, mailingListKey) {
    const eventObj = {
      hitType: 'event',
      eventCategory: 'Mailing List',
      eventAction: mailingListKey,
      eventLabel: source
    };

    eventValue && (eventObj.eventValue = eventValue);
    ga('send', eventObj);
  }

  trackAdClick(source = 'Unknown Source', eventValue, isExpanded = false) {
    const eventObj = {
      hitType: 'event',
      eventCategory: 'Ads',
      eventAction: isExpanded ? 'ClickAfterExpand' : 'Click',
      eventLabel: source
    };

    eventValue && (eventObj.eventValue = eventValue);
    ga('send', eventObj);
  }

  trackAdExpandClick(source = 'Unknown Source', eventValue) {
    const eventObj = {
      hitType: 'event',
      eventCategory: 'AdsExapnd',
      eventAction: 'Expand',
      eventLabel: source
    };

    eventValue && (eventObj.eventValue = eventValue);
    ga('send', eventObj);
  }

  trackAdSaleLMKEvent(source = 'Unknown Source', eventValue, isSubmit) {
    const eventObj = {
      hitType: 'event',
      eventCategory: 'AdsSaleLMK',
      eventAction: isSubmit ? 'SaleLMKSubmitted' : 'SaleLMKClicked',
      eventLabel: source
    };

    eventValue && (eventObj.eventValue = eventValue);
    ga('send', eventObj);
  }
}

const analytics = new Analytics();
export default analytics;